import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useNotificationStore } from 'stores/notifications';
import { useMutation } from 'react-query';

export const depositToWallet = ({ data }) => {
  return axios.post(`/transaction/addDeposit`, data);
};

export const useDepositToWallet = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onMutate: async (newDeposit) => {},
    onError: (_, __, context) => {},
    onSuccess: (data) => {},
    ...config,
    mutationFn: depositToWallet,
  });
};
